<h1 mat-dialog-title>Add Test Details</h1>
<div mat-dialog-content>
  <div class="modal-content-wrap">
    <form [formGroup]="testAddForm">
      <div class="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label for="">test  Name</label>
          <input type="text" formControlName="test_name" />
        </div>
        <div>
          <label for="">Test Section</label>
          <mat-select class="selection max-w-[-webkit-fill-available]"  formControlName="test_section_id" placeholder="">
              <mat-option [value]="testType.id" *ngFor="let testType of dataSource">
                {{testType.test_section}}
              </mat-option>
          </mat-select>

        </div>
      </div>
      <div class="w-full py-3">
        <mat-slide-toggle formControlName="status">Active</mat-slide-toggle>
      </div>
    </form>
  </div>
</div>
<div mat-dialog-actions class="items-center justify-end gap-2">
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button *ngIf="!editMode" mat-button class="btn-primary" (click)="testAddFormSubmit()">
    Add
  </button>
  <button *ngIf="editMode" mat-button class="btn-primary" (click)="testEditFormSubmit()">
    Update
  </button>
</div>
